import { FlatButton, stenaDownload } from "@stenajs-webui/elements";
import { downloadExcelForStandardTable } from "@stenajs-webui/grid-export";
import { testIdConstants } from "@/types/test-id-constants/testIdConstants";
import { useMemo } from "react";
import { rebateBookingsExcelConfig } from "../../config/RebateBookingsExcelConfig";
import {
  createRebateBookingsExportFilename,
  getReservedBookingsForExport,
} from "../../lib/reservedBookingUtils";
import { RebateBookingsOverview } from "../../types/types";

interface Props {
  rebate: RebateBookingsOverview;
}

export const RebateBookingsExportButton = ({ rebate }: Props) => {
  const bookings = useMemo(
    () => getReservedBookingsForExport(rebate),
    [rebate]
  );

  if (bookings.length === 0) {
    return null;
  }

  return (
    <FlatButton
      label={"Export to Excel"}
      leftIcon={stenaDownload}
      data-testid={testIdConstants.rebateBookingsExportButton}
      onClick={() =>
        downloadExcelForStandardTable(
          createRebateBookingsExportFilename(rebate),
          rebateBookingsExcelConfig,
          bookings
        )
      }
    />
  );
};
